import { render, staticRenderFns } from "./PartnerAdd.vue?vue&type=template&id=b9bb6c32&scoped=true&"
import script from "./PartnerAdd.vue?vue&type=script&lang=js&"
export * from "./PartnerAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9bb6c32",
  null
  
)

export default component.exports